import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

// The Item Search island's record of the manufacturers picked from its menu —
// `handleAddManufacturerFilter`'s `updateItemsObjectCache` (#987), which names
// the pick's chip at once though no read has carried it. The island names its
// chips from this beside its reads (`useIslandManufacturerNames`).
//
// **Held by the query client** (ADR-0014 §2: no store beside TanStack Query,
// never component state): the island observes it while mounted, and TanStack's
// gc time keeps it after, a lifetime the ticket licenses. Keyed beside the
// island's prefix, not under it: everything under it is a read the island
// walks for items.

export interface PickedManufacturer {
  id: number;
  name: string;
}

export const islandManufacturerPicksQueryKey = ["item-search-island-manufacturer-picks"] as const;

/** Record a pick on this provider's client, replacing its earlier name. */
export function useRememberIslandManufacturer() {
  const queryClient = useQueryClient();
  return useCallback(
    (picked: PickedManufacturer) =>
      queryClient.setQueryData<PickedManufacturer[]>(
        islandManufacturerPicksQueryKey,
        (picks = []) => [
          ...picks.filter(({ id }) => id !== picked.id),
          { id: picked.id, name: picked.name },
        ],
      ),
    [queryClient],
  );
}
